import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gothic';
    src: url(${Gothic});
  }   

  .generated-images-holder {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }

  .author-row {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }

  .author-name {
    font-weight: 700;
    font-size: 34px;
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
  }

  .author-name__blue {
    color: #3D5798;
  }

  .author-image {
    width: 93px;
    height: 93px;
    object-fit: cover;
    margin-right: 22px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .right-text-holder {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    background-color: white;
    padding: 33px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .right-text {
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.05em;
    line-height: 1.2;
    p {
      display: inline;
    }
  }
  .break {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  .half-image {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    &--reversed {
      order: 2;
    }
  }
  .left-actual-photo {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    z-index: 1;
    &--reversed {
      left: auto;
      right: 0;
    }
  }
  .left-actual-photo--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
